import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3dfc5a25"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "catalog-item"
};
const _hoisted_2 = {
  class: "catalog-img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "catalog-author"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _directive_img = _resolveDirective("img");

  return _openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.authors, item => {
    return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
      to: {
        name: 'author',
        params: {
          id: item.id
        }
      },
      class: "catalog-col",
      key: item.id
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: item.thumbWithPath,
        alt: ""
      }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
        to: {
          name: 'author',
          params: {
            id: item.id
          }
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["to"])])])]),
      _: 2
    }, 1032, ["to"])), [[_directive_img, {
      classes: ['.catalog-img img']
    }]]);
  }), 128);
}